<template>
  <div class="backProcess-container">
    <!-- 竖向步骤条 -->
    <div class="steps-wrapper">
      <van-steps direction="vertical" :active="detailStep">
        <van-step>
          <p>上传商品图片和描述信息</p>
          <div class="step1">
            <van-field
              v-model="huishouDetail.descriptions"
              label="商品描述"
              type="textarea"
              rows="3"
            />
            <van-image
              v-for="(item, index) in huishouFileList"
              :key="index"
              width="100"
              height="100"
              :src="item"
              @click="previewImage(index)"
            />
          </div>
        </van-step>
        <van-step>
          <p>
            客服评估商品价格
            <span
              @click="startChat()"
              style="margin-left: 20px; text-decoration: underline;color: #1989fa;"
              ><van-icon size="20" name="chat" />提前咨询客服</span
            >
          </p>
          <div class="content-header"></div>
          <van-cell-group v-if="huishouDetail.assessPrice">
            <van-cell title="预估价格" :value="huishouDetail.assessPrice">
              <template #value>
                <span class="estimated-price">{{
                  huishouDetail.assessPrice
                }}</span>
              </template>
            </van-cell>
          </van-cell-group>

          <div class="evaluation-info">
            <van-notice-bar
              v-if="!huishouDetail.assessPrice"
              left-icon="info-o"
              text="客服正在评估中，请耐心等待..."
            />
            <div v-if="huishouDetail.assessPrice">
              <van-notice-bar left-icon="success" text="客服评估完成" />
              <br />
              <div
                style="
                  display: flex;
                  justify-content: center;
                  margin-top: 0.5px;
                "
              >
                <van-button
                  v-if="huishouDetail.status == 2"
                  type="default"
                  style="margin-right: 5px"
                  @click="showRejectDialog"
                  >拒绝</van-button
                >
                <van-button
                  v-if="huishouDetail.status == 2"
                  type="primary"
                  @click="acceptOffer"
                  >接受</van-button
                >
                <!-- <van-button v-else style="margin-left: 5px;" type="primary" @click="startChat()">联系客服</van-button> -->
              </div>
            </div>
          </div>
        </van-step>
        <van-step>
          <p>完成回收获得奖励</p>
          <div class="content-header"></div>
          <van-cell-group>
            <van-cell title="最终价格">
              <template #value>
                <span class="estimated-price">{{
                  huishouDetail.assessPrice
                }}</span>
              </template>
            </van-cell>
            <van-cell title="回收状态" value="已完成">
              <template #value>
                <van-tag
                  type="primary"
                  size="medium"
                  v-if="huishouDetail.status == 1"
                  >评估中</van-tag
                >
                <van-tag
                  type="primary"
                  size="medium"
                  v-if="huishouDetail.status == 2"
                  >已评估</van-tag
                >
                <van-tag
                  type="primary"
                  size="medium"
                  v-if="huishouDetail.status == 3"
                  >已接收</van-tag
                >
                <van-tag
                  type="primary"
                  size="medium"
                  v-if="huishouDetail.status == 4"
                  >已拒绝</van-tag
                >
                <van-tag
                  type="primary"
                  size="medium"
                  v-if="huishouDetail.status == 5"
                  >已完成</van-tag
                >
                <van-tag
                  type="primary"
                  size="medium"
                  v-if="huishouDetail.status == 6"
                  >已取消</van-tag
                >
              </template>
            </van-cell>
          </van-cell-group>

          <div class="success-info">
            <van-icon name="success" size="48" color="#07c160" />
            <p>回收完成！</p>
            <p>款项将在10-15分钟内到账</p>
          </div>
        </van-step>
      </van-steps>
    </div>

    <!-- 拒绝确认弹框 -->
    <van-dialog
      v-model:show="showRejectConfirm"
      title="拒绝回收"
      message="您确定要拒绝此次回收报价吗？"
      show-cancel-button
    >
      <template #footer>
        <div class="dialog-footer">
          <van-button
            size="large"
            type="default"
            @click="handleRejectDialog"
            style="margin-right: 12px"
          >
            取消
          </van-button>
          <van-button
            size="large"
            type="default"
            @click="directReject"
            style="margin-right: 12px"
          >
            直接拒绝
          </van-button>
          <!-- <van-button 
            size="large" 
            type="primary" 
            @click="contactCustomerService"
          >
          联系客服
          </van-button> -->
          <!-- <van-button 
            size="large" 
            type="primary" 
            @click="startChat"
          >
          联系客服
          </van-button> -->
        </div>
      </template>
    </van-dialog>
  </div>
</template>

<script>
// 导入 Vant 4 的 showToast 和 showDialog
import { showToast, showDialog, showImagePreview } from "vant";
import request from "@/utils/request";
export default {
  name: "BackProcess",
  data() {
    return {
      active: 1,
      currentStatus: "processing",
      productName: "",
      productDesc: "",
      estimatedPrice: "",
      evaluationStatus: "评估完成",
      canProceed: true,
      fileList: [],
      showRejectConfirm: false, // 控制拒绝确认弹框显示
      recyclerId: "",
      huishouDetail: {},
      huishouFileList: [],
      detailStep: 0,
    };
  },
  created() {
    this.recyclerId = this.$route.query.recyclerId;
    this.getHuishouInfo();
  },

  methods: {
    getHuishouInfo() {
      request
        .get("/front/platform/recycler/process", {
          params: {
            recyclerId: this.recyclerId, //回收数据ID
          },
        })
        .then((res) => {
          if (res.code == 200) {
            this.huishouDetail = res.data.recyclerInfo;
            console.log(this.huishouDetail);
            this.huishouFileList = this.huishouDetail.imgUrls;
            this.detailStep = this.huishouDetail.step;
          }
        });
    },
    // 显示拒绝确认弹框
    showRejectDialog() {
      this.showRejectConfirm = true;
    },

    // 处理拒绝弹框的关闭事件
    handleRejectDialog(action) {
      this.showRejectConfirm = false;
    },

    // 直接拒绝
    directReject() {
      showDialog({
        title: "确认拒绝",
        message: "确认拒绝报价吗？",
        showCancelButton: true,
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then(() => {
          request
            .get(
              "/front/platform/recycler/update?recyclerId=" +
                this.huishouDetail.recyclerId +
                "&status=4"
            )
            .then((res) => {
              if (res.code == 200) {
                showToast("已拒绝报价");
              }
            });
        })
        .catch(() => {
          // 点击取消，不做任何操作
        });
    },

    // 联系客服
    contactCustomerService() {
      this.showRejectConfirm = false;
      this.$router.push("/chat");
    },
    previewImage(index) {
      showImagePreview({
        images: this.huishouFileList,
        startPosition: index,
        closeable: true,
      });
    },
    // 接受报价
    acceptOffer() {
      showDialog({
        title: "确认接受",
        message: "确认接受报价吗？",
        showCancelButton: true,
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then(() => {
          request
            .get(
              "/front/platform/recycler/update?recyclerId=" +
                this.huishouDetail.recyclerId +
                "&status=3"
            )
            .then((res) => {
              if (res.code == 200) {
                showToast("已接受报价，请进行交易确认");
                this.getHuishouInfo();
                window.open(
                  "https://work.weixin.qq.com/kfid/kfc0afede0891281246"
                );
              }
            });
        })
        .catch(() => {
          // 点击取消，不做任何操作
        });
    },
    startChat() {
      // this.$router.push('/chat')
      window.open("https://work.weixin.qq.com/kfid/kfc0afede0891281246");
    },

    prevStep() {
      if (this.active > 0) {
        this.active--;
      }
    },

    afterRead(file) {
      console.log("上传文件:", file);
      this.fileList = [];
      this.fileList = [file];
    },

    goHome() {
      this.$router.push("/");
    },
  },
};
</script>

<style scoped>
.backProcess-container {
  height: 100vh;
  display: flex;
  background-color: #f7f8fa;
}

/* 步骤条区域 */
.steps-wrapper {
  width: 200px;
  background: white;
  padding: 20px 16px;
  box-shadow: 2px 0 8px rgba(0, 0, 0, 0.1);
  overflow-y: auto;
}

/* 内容区域 */
.content-container {
  flex: 1;
  padding: 20px 16px;
  overflow-y: auto;
}

.content-header {
  margin-bottom: 20px;
}

.content-header h3 {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: #323233;
}

.step-content {
  background: white;
  border-radius: 8px;
  padding: 20px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.upload-section {
  padding: 16px 0;
  margin: 16px 0;
}

.evaluation-info {
  margin: 16px 0;
}

.success-info {
  text-align: center;
  padding: 40px 20px;
  margin: 16px 0;
}

.success-info p {
  margin: 8px 0;
  color: #646566;
}

.action-buttons {
  display: flex;
  gap: 12px;
  margin-top: 24px;
}

.action-buttons .van-button {
  flex: 1;
}

/* 弹框底部按钮样式 */
.dialog-footer {
  display: flex;
  padding: 16px;
  gap: 12px;
}

.dialog-footer .van-button {
  flex: 1;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .backProcess-container {
    flex-direction: column;
  }

  .steps-wrapper {
    width: 100%;
    padding: 16px;
  }

  .content-container {
    padding: 16px;
  }
}

/* 自定义步骤条样式 */
.steps-wrapper :deep(.van-step__title) {
  font-size: 16px;
  font-weight: 600;
}

.steps-wrapper :deep(.van-step__content) {
  margin-top: 8px;
}

.steps-wrapper :deep(.van-step__content p) {
  font-size: 14px;
  color: #969799;
  margin: 0;
}

.estimated-price {
  color: #ee0a24;
  font-size: 18px;
  font-weight: bold;
}
</style>
